import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=01d3e8db&scoped=true"
import script from "./Client.vue?vue&type=script&lang=ts"
export * from "./Client.vue?vue&type=script&lang=ts"
import style0 from "./Client.vue?vue&type=style&index=0&id=01d3e8db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d3e8db",
  null
  
)

export default component.exports